import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnWindowFocus: false,
      retry: (failureCount, error: unknown) => {
        // Don't retry on 401/403 errors
        if (
          (error as { response?: { status?: number } })?.response?.status === 401 ||
          (error as { response?: { status?: number } })?.response?.status === 403
        ) {
          return false;
        }
        return failureCount < 3;
      },
    },
  },
});
